
export const FETCH_BINBATCH_REQUEST = "FETCH_BINBATCH_REQUEST";
export const FETCH_BINBATCH_SUCCESS = "FETCH_BINBATCH_SUCCESS";
export const FETCH_BINBATCH_FAILURE = "FETCH_BINBATCH_FAILURE";

export const FETCH_ORGANIZATION_REQUEST = "FETCH_ORGANIZATION_REQUEST";
export const FETCH_ORGANIZATION_SUCCESS = "FETCH_ORGANIZATION_SUCCESS";
export const FETCH_ORGANIZATION_FAILURE = "FETCH_ORGANIZATION_FAILURE";

export const FETCH_SEASON_REQUEST = "FETCH_SEASON_REQUEST";
export const FETCH_SEASON_SUCCESS = "FETCH_SEASON_SUCCESS";
export const FETCH_SEASON_FAILURE = "FETCH_SEASON_FAILURE";

export const FETCH_BINMASTER_REQUEST = "FETCH_BINMASTER_REQUEST";
export const FETCH_BINMASTER_SUCCESS = "FETCH_BINMASTER_SUCCESS";
export const FETCH_BINMASTER_FAILURE = "FETCH_BINMASTER_FAILURE";

export const FETCH_DRYING_REQUEST = "FETCH_DRYING_REQUEST";
export const FETCH_DRYING_SUCCESS = "FETCH_DRYING_SUCCESS";
export const FETCH_DRYING_FAILURE = "FETCH_DRYING_FAILURE";

export const FETCH_DRYINGLINE_REQUEST = "FETCH_DRYINGLINE_REQUEST";
export const FETCH_DRYINGLINE_SUCCESS = "FETCH_DRYINGLINE_SUCCESS";
export const FETCH_DRYINGLINE_FAILURE = "FETCH_DRYINGLINE_FAILURE";